import React from "react";
import { motion } from "framer-motion";
import "./FeatureCard.css";


const FeatureCard = ({ features }) => {

    return (

        <div className="container">

            <div className="feature-grid">

                {
                features?.map((item,index)=>(

                <motion.div

                    key={item.id}

                    className="feature-item"


                    initial={{
                        opacity:0,
                        y:40
                    }}


                    whileInView={{
                        opacity:1,
                        y:0
                    }}


                    viewport={{
                        once:true
                    }}


                    transition={{
                        duration:.5,
                        delay:index*.15
                    }}


                    whileHover={{
                        y:-8
                    }}

                >


                    <div className="feature-card">


                        <motion.div

                            className="feature-img-wrapper"


                            whileHover={{
                                scale:1.08
                            }}

                        >

                            <img

                                src={item.image}

                                alt={item.title}

                                className="feature-image"

                            />

                        </motion.div>



                        <h6 className="feature-title">

                            {item.title}

                        </h6>


                    </div>


                </motion.div>


                ))

                }


            </div>

        </div>

    );

};


export default FeatureCard;